import type { FC } from 'react';
import { StyledContainer, StyledHeader } from './header.styles';
import { Logo } from '../Logo/logo.component';
import { Button } from '../Button/button.component';
import { PATH } from '../../app.type';
import { Menu } from '../Menu/menu.component';
import { useTheme } from 'styled-components';
import { useMediaQuery } from '../../hooks/media-query.hook';

export const Header: FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.media.tablet.replace('@media ', ''));

  return (
    <StyledHeader>
      <StyledContainer>
        <Logo position="horizontal" />
        <Menu />
        {isMobile ? null : (
          <Button text="Skontaktuj się" to={PATH.CONTACT} type="outline" />
        )}
      </StyledContainer>
    </StyledHeader>
  );
};
